import styled from 'styled-components';

import { QuestionMarkIcon } from '../../assets';
import { ThemeProp } from '../../theme/Themes';
import Tooltip from '../Tooltip/Tooltip';
import { TooltipTrigger } from '../Tooltip/Tooltip.styles';

export const HelpContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props: ThemeProp) => props.theme.colors.c100};
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
`;

export const StyledQuestionMarkIcon = styled(QuestionMarkIcon)`
  opacity: 1;
  fill: ${(props: ThemeProp) => props.theme.colors.c400};
  width: 0.5rem;
  height: 0.5rem;
`;

export const StyledTooltip = styled(Tooltip)`
  display: flex;
  ${TooltipTrigger} {
    width: fit-content;
    margin: 0 0.375rem;
  }
`;
